import Vue from 'vue'
import Router from 'vue-router'

import Home from './components/Home.vue'
import NotFound from './components/NotFound.vue'
import LoginError from './components/authentication/LoginError.vue'
import LoggingIn from './components/authentication/LoggingIn.vue'
import LogOut from './components/authentication/LogOut.vue'
import LoggedOut from './components/authentication/LoggedOut.vue'
import NotAuthorized from './components/authentication/NotAuthorized.vue'

import GPReporting from './components/reports/GPReporting.vue'
import ProductReporting from './components/reports/ProductReporting.vue'
import OrdersSentReporting from './components/reports/OrdersSentReporting.vue'
import OrderReporting from './components/reports/OrderReporting.vue'

import CategoryManagement from './components/admin/CategoryManagement'
import ProductManagement from './components/admin/ProductManagement'
import StoresAndDepartments from './components/admin/StoresAndDepartments'
import UserManagementPage from './components/admin/UserManagementPage'
import SupplierManagement from './components/admin/SupplierManagement'

import AuditLogPage from './components/audit/AuditLogPage'
import BankingDetailsPage from './components/audit/BankingDetailsPage'

import CheckBankingDetailsPage from './components/audit/CheckBankingDetailsPage'

import AssignSuppliers from './components/datamanagement/AssignSuppliers'
import PublicHolidaysPage from './components/datamanagement/PublicHolidaysPage'
import AssignToStoresPage from './components/datamanagement/AssignToStoresPage'

import OrderSummary from './components/orders/OrderSummary.vue'
import PlaceOrderPage from './components/orders/PlaceOrderPage.vue'
import PreviousOrdersPage from './components/orders/PreviousOrdersPage.vue'
import ViewOrderDetailsPage from './components/orders/ViewOrderDetailsPage.vue'

import auth from "./services/auth"
import store from "./store";
import constant from "./services/constant"

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: "Home",
                requiredPermissions: [
                    "access",
                    "order"
                ]
            }
        },
        {
            path: '/login', // This is intercepted, so nothing to display
            name: 'login',
            meta: {
                title: "Login",
                hideMenus: true,
                notDefault: true
            }
        },
        {
            path: '/loggingin', // This is intercepted, so nothing to display
            name: 'loggingin',
            component: LoggingIn,
            meta: {
                title: "Logging In...",
                hideMenus: true,
                notDefault: true
            }
        },
        {
            path: '/loginerror',
            name: 'loginerror',
            component: LoginError,
            meta: {
                title: "Login Error",
                hideMenus: true,
                notDefault: true
            }
        },
        {
            path: '/logout', // This is intercepted, so nothing to display
            name: 'logout',
            component: LogOut,
            meta: {
                title: "Logging Out...",
                hideMenus: true,
                notDefault: true
            }
        },
        {
            path: '/loggedout',
            name: 'loggedout',
            component: LoggedOut,
            meta: {
                title: "Logged Out",
                hideMenus: true,
                notDefault: true
            }
        },
        {
            path: '/notauthorized',
            name: 'notauthorized',
            component: NotAuthorized,
            meta: {
                title: "Not Authorized",
                notDefault: true
            }
        },
        {
            path: '/reports/costreport',
            name: 'costreport',
            component: GPReporting,
            meta: {
                title: "Cost Report",
                requiredPermissions: [
                    "access",
                    "report"
                ]
            }
        },
        {
            path: '/reports/orderreport',
            name: 'orderreport',
            component: OrderReporting,
            meta: {
                title: "GP Report",
                requiredPermissions: [
                    "access",
                    "report"
                ]
            }
        },
        {
            path: '/reports/productreport',
            name: 'productreport',
            component: ProductReporting,
            meta: {
                title: "Product Report",
                requiredPermissions: [
                    "access",
                    "report"
                ]
            }
        },
        {
            path: '/reports/orderssentreport',
            name: 'orderssentreport',
            component: OrdersSentReporting,
            meta: {
                title: "Supplier Order Listing",
                requiredPermissions: [
                    "access",
                    "report"
                ]
            }
        },
        {
            path: '/data/auditlog',
            name: 'auditlog',
            component: AuditLogPage,
            meta: {
                title: "Audit Log",
                requiredPermissions: [
                    "access",
                    "admin"
                ]
            }
        },
        {
            path: '/data/bankingdetails/jcg',
            name: 'bankingdetailsjcg',
            component: BankingDetailsPage,
            meta: {
                title: "Banking Details > JCG",
                requiredPermissions: [
                    "access",
                    constant.CompanyID.JCG.AccessRight
                ],
                companyID: constant.CompanyID.JCG.ID
            }
        },
        {
            path: '/data/bankingdetails/sbd',
            name: 'bankingdetailssbd',
            component: BankingDetailsPage,
            meta: {
                title: "Banking Details > CGMS",
                requiredPermissions: [
                    "access",
                    constant.CompanyID.SBD.AccessRight
                ],
                companyID: constant.CompanyID.SBD.ID
            }
        },
        {
            path: '/data/bankingdetails/crg',
            name: 'bankingdetailscrg',
            component: BankingDetailsPage,
            meta: {
                title: "Banking Details > CRG",
                requiredPermissions: [
                    "access",
                    constant.CompanyID.CRG.AccessRight
                ],
                companyID: constant.CompanyID.CRG.ID
            }
        },
        {
            path: '/data/bankingdetails/cg',
            name: 'bankingdetailscg',
            component: BankingDetailsPage,
            meta: {
                title: "Banking Details > Supplier Audit",
                requiredPermissions: [
                    "access",
                    constant.CompanyID.CG.AccessRight
                ],
                companyID: constant.CompanyID.CG.ID
            }
        },
        {
            path: '/data/checkbankingdetails/jcg',
            name: 'checkbankingdetailsjcg',
            component: CheckBankingDetailsPage,
            props: true,
            meta: {
                title: "Check Banking Details > JCG",
                requiredPermissions: [
                    "access",
                    constant.CompanyID.JCG.AccessRight
                ],
                companyID: constant.CompanyID.JCG.ID
            }
        },
        {
            path: '/data/checkbankingdetails/sbd',
            name: 'checkbankingdetailssbd',
            component: CheckBankingDetailsPage,
            props: true,
            meta: {
                title: "Check Banking Details > CGMS",
                requiredPermissions: [
                    "access",
                    constant.CompanyID.SBD.AccessRight
                ],
                companyID: constant.CompanyID.SBD.ID
            }
        },
        {
            path: '/data/checkbankingdetails/crg',
            name: 'checkbankingdetailscrg',
            component: CheckBankingDetailsPage,
            props: true,
            meta: {
                title: "Check Banking Details > CRG",
                requiredPermissions: [
                    "access",
                    constant.CompanyID.CRG.AccessRight
                ],
                companyID: constant.CompanyID.CRG.ID
            }
        },
        {
            path: '/data/checkbankingdetails/cg',
            name: 'checkbankingdetailscg',
            component: CheckBankingDetailsPage,
            props: true,
            meta: {
                title: "Check Banking Details > CG",
                requiredPermissions: [
                    "access",
                    constant.CompanyID.CG.AccessRight
                ],
                companyID: constant.CompanyID.CG.ID
            }
        },
        {
            path: '/data/assignsuppliers',
            name: 'assignsuppliers',
            component: AssignSuppliers,
            meta: {
                title: "Assign Suppliers",
                requiredPermissions: [
                    "access",
                    "assignsuppliers"
                ]
            }
        },
        {
            path: '/data/assigntostores',
            name: 'assigntostores',
            component: AssignToStoresPage,
            meta: {
                title: "Assign To Stores",
                requiredPermissions: [
                    "access",
                    "assignsuppliers"
                ]
            }
        },
        {
            path: '/data/publicholidays',
            name: 'publicholidays',
            component: PublicHolidaysPage,
            meta: {
                title: "Public Holidays",
                requiredPermissions: [
                    "access",
                    "managedata"
                ]
            }
        },
        {
            path: '/admin/categories',
            name: 'categories',
            component: CategoryManagement,
            meta: {
                title: "Categories",
                requiredPermissions: [
                    "access",
                    "managedata"
                ]
            }
        },
        {
            path: '/admin/products',
            name: 'products',
            component: ProductManagement,
            meta: {
                title: "Products",
                requiredPermissions: [
                    "access",
                    "managedata"
                ]
            }
        },
        {
            path: '/admin/storesanddepartments',
            name: 'storesanddepartments',
            component: StoresAndDepartments,
            meta: {
                title: "Stores and Departments",
                requiredPermissions: [
                    "access",
                    "managedata"
                ]
            }
        },
        {
            path: '/admin/suppliers',
            name: 'suppliers',
            component: SupplierManagement,
            meta: {
                title: "Suppliers",
                requiredPermissions: [
                    "access",
                    "managedata"
                ]
            }
        },
        {
            path: '/admin/users',
            name: 'users',
            component: UserManagementPage,
            meta: {
                title: "Users",
                requiredPermissions: [
                    "access",
                    "manageusers"
                ]
            }
        },
        {
            path: '/orders/placeorder',
            name: 'placeorder',
            component: PlaceOrderPage,
            meta: {
                title: "Place Order",
                requiredPermissions: [
                    "access",
                    "order"
                ]
            }
        },
        {
            path: '/orders/placeorder/:editOrderID',
            name: 'editorder',
            component: PlaceOrderPage,
            props: true,
            meta: {
                title: "Place Order",
                requiredPermissions: [
                    "access",
                    "order"
                ]
            }
        },
        {
            path: '/orders/previousorders',
            name: 'previousorders',
            component: PreviousOrdersPage,
            meta: {
                title: "Previous Orders",
                requiredPermissions: [
                    "access",
                    "order"
                ]
            }
        },
        {
            path: '/orders/:backRouteName/vieworderdetails/:orderID/',
            name: 'vieworderdetails',
            component: ViewOrderDetailsPage,
            props: true,
            meta: {
                title: "Previous Orders",
                requiredPermissions: [
                    "access",
                    "order"
                ]
            }
        },
        { 
            path: "*", 
            component: NotFound,
            meta: {
                title: "Page Not Found",
                requiredPermissions: [
                    "access",
                    "order"
                ]
            }
        }
    ]
})

// // Global route guard
router.beforeEach((to, from, next) => {
    // Use the page's router title to name the page
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }

    store.commit("generalStore/setLoadingRoute", true);

    // Check if not authenticated
    auth.acquireToken().then(token => {
        store.commit("generalStore/setLoadingRoute", false);

        // From here onwards we are authenticated

        // Check if we are going to the logging in page (this would indicate not having a profile loaded in auth - i.e., after initial AD login)
        if(to.name === "loggingin"){
            auth.processLogin().then(() => {
                // Redirect to the default page 
                router.push({
                    path: "/"
                });
            }, () => {
                router.push({
                    path: "/loginerror"
                });
            });
            next();
            return;
        }

        // Check if we are going to the login error page (this would indicate a failed auth.processLogin() - i.e., something wrong with system user rather than AD user)
        if(to.name === "loginerror"){
            // Display the page
            next();
            return;
        }

        // Check if we are going to the logout page (this would indicate a request to log out)
        if(to.name === "logout"){
            // Redirect user to AD logout
            auth.signOut();
            next();
            return;
        }

        // Check if we are going to the logged out page (this would indicate a user has refreshed/navigated to the logged out page,
        // which is not really useful if they are logged in)
        if(to.name === "loggedout"){
            // Redirect to the default page 
            next({
                path: "/"
            });
            return;
        }

        // Check if this is the first time we have been authenticated (this would indicate a redirect back from AD login)
        if(auth.needToProcessLogin()){
            // Redirect to the logging in page 
            next({
                path: "/loggingin"
            });
            return;
        }

        // From here onwards we are not part of the login/logout flow

        // Check if this user is authorised
        if(to.meta && to.meta.requiredPermissions && !auth.hasPermissions(to.meta.requiredPermissions)){
            // Not authorized to see page, redirect to the default page

            // If we were trying to access the default path, instead redirect to default page that we do have access to
            if(to.path == "/"){
                let defaultRoute = router.options.routes.find(r => {
                    if(!r.meta){
                        return true;
                    }

                    if(r.meta.notDefault){
                        return false;
                    }

                    if(!r.meta.requiredPermissions){
                        return true;
                    }

                    if(auth.hasPermissions(r.meta.requiredPermissions)){
                        return true;
                    }

                    return false;
                });
                if(defaultRoute){
                    next({
                        name: defaultRoute.name
                    });
                    return;
                }
            }

            // Otherwise show not authorized page
            next({
                path: "/notauthorized"
            });
            return;
        }

        // Either user is authorized to see the page or no authorisation applied to the page
        // Display the page
        next();
        return;
    }).catch(err => {
        store.commit("generalStore/setLoadingRoute", false);

        // Check if failure is from the user and not the token
        if(err.userError){
            next({
                path: "/loginerror"
            });
            return;
        }

        // From here onwards we are not authenticated

        // Since we are not authenticated, forget what we know about the user (i.e., in the case of login expire)
        auth.forgetUser();

        // Check if we are going to the login page (this would indicate a request to log in)
        if(to.name === "login"){
            // Redirect user to AD login
            auth.signIn();
            next();
            return;
        }

        // Check if we are going to the logout page (this would indicate a redirect back from AD logout)
        if(to.name === "loggedout"){
            // This is fine, display the page
            next();
            return;
        }

        // Go to the login page
        next({
            path: "/login"
        });
        return;
    });
});

export default router;